<section hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle>
      @if (result()) {
        Eingelöst
      } @else if (step() === 'review') {
        Bitte prüfen
      } @else {
        Gutschein einlösen
      }
    </h2>
    @if (!result() && step() === 'review') {
      <p hlmCardDescription>Eine Einlösung lässt sich nicht rückgängig machen.</p>
    }
  </div>

  <div hlmCardContent class="space-y-4">
    <!-- ══════════ Done ══════════ -->
    @if (result(); as result) {
      <div hlmAlert variant="info">
        <ng-icon name="lucideCircleCheck" />
        <p hlmAlertTitle>{{ money(result.redeemed) }} eingelöst</p>
        <p hlmAlertDescription>
          @if (result.remaining > 0) {
            Auf dem Gutschein {{ code() }} sind noch {{ money(result.remaining) }} übrig.
          } @else {
            Der Gutschein {{ code() }} ist damit vollständig eingelöst.
          }
        </p>
      </div>

      <dl class="grid grid-cols-2 gap-4 text-center">
        <div>
          <dt hlmMuted class="text-xs">Eingelöst</dt>
          <dd class="text-lg font-semibold tabular-nums">{{ money(result.redeemed) }}</dd>
        </div>
        <div>
          <dt hlmMuted class="text-xs">Restguthaben</dt>
          <dd class="text-lg font-semibold tabular-nums">{{ money(result.remaining) }}</dd>
        </div>
      </dl>

      <ng-content select="[resultNote]" />

      <div class="flex flex-col gap-2">
        <ng-content select="[resultActions]" />
        @if (result.remaining > 0) {
          <button hlmBtn variant="outline" class="w-full" (click)="continue()">
            Weiter einlösen
          </button>
        }
      </div>
    } @else if (locked()) {
      <!-- ══════════ Locked ══════════ -->
      <div hlmAlert variant="destructive">
        <ng-icon name="lucideLock" />
        <p hlmAlertTitle>{{ errorTitle() }}</p>
        <p hlmAlertDescription>{{ error() }}</p>
      </div>
    } @else if (step() === 'review') {
      <!-- ══════════ Review ══════════ -->
      <dl class="bg-muted divide-border divide-y rounded-lg border text-sm">
        <div class="flex items-center justify-between gap-4 px-4 py-3">
          <dt hlmMuted>Gutschein</dt>
          <dd class="font-mono font-medium">{{ code() }}</dd>
        </div>
        @if (location()) {
          <div class="flex items-center justify-between gap-4 px-4 py-3">
            <dt hlmMuted>Standort</dt>
            <dd class="text-right font-medium">{{ location() }}</dd>
          </div>
        }
        <div class="flex items-center justify-between gap-4 px-4 py-3">
          <dt hlmMuted>
            {{ isFull() ? 'Einlösen (gesamtes Guthaben)' : 'Einlösen (Teilbetrag)' }}
          </dt>
          <dd class="text-2xl font-semibold tabular-nums">{{ money(amountCents()) }}</dd>
        </div>
        <div class="flex items-center justify-between gap-4 px-4 py-3">
          <dt hlmMuted>Restguthaben danach</dt>
          <dd class="font-medium tabular-nums">{{ money(balance() - amountCents()) }}</dd>
        </div>
      </dl>

      <div class="flex flex-col-reverse gap-2 sm:flex-row">
        <button
          hlmBtn
          variant="outline"
          class="w-full sm:flex-1"
          [disabled]="busy()"
          (click)="step.set('enter')">
          Zurück
        </button>
        <button hlmBtn class="w-full sm:flex-1" [disabled]="busy()" (click)="confirm()">
          @if (busy()) {
            <hlm-spinner />
            Wird eingelöst…
          } @else {
            {{ money(amountCents()) }} jetzt einlösen
          }
        </button>
      </div>
    } @else {
      <!-- ══════════ Enter ══════════ -->
      @if (error()) {
        <div hlmAlert variant="destructive">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ errorTitle() }}</p>
          <p hlmAlertDescription>{{ error() }}</p>
          <div hlmAlertAction>
            <button
              hlmBtn
              variant="ghost"
              size="icon-sm"
              aria-label="Schließen"
              (click)="errorDismissed.emit()">
              <ng-icon name="lucideX" />
            </button>
          </div>
        </div>
      }

      <form class="space-y-4" (ngSubmit)="review()">
        <ng-content />

        <div hlmField>
          <label hlmFieldLabel for="redemption-amount">Betrag</label>
          <hlm-input-group class="w-full">
            <input
              hlmInputGroupInput
              id="redemption-amount"
              name="amount"
              type="text"
              inputmode="decimal"
              autocomplete="off"
              class="text-lg tabular-nums"
              [maskito]="amountMask"
              [attr.aria-invalid]="amountError() ? 'true' : null"
              [ngModel]="amountText()"
              (ngModelChange)="amountText.set($event); amountError.set('')" />
            <hlm-input-group-addon align="inline-end">
              <span hlmInputGroupText>{{ currencySymbol() }}</span>
            </hlm-input-group-addon>
          </hlm-input-group>
          @if (amountError()) {
            <p class="text-destructive text-xs">{{ amountError() }}</p>
          } @else {
            <p hlmFieldDescription>
              Guthaben: {{ money(balance()) }}.
              @if (isFull()) {
                Für einen Teilbetrag einfach überschreiben.
              } @else {
                <button
                  type="button"
                  class="text-primary underline-offset-4 hover:underline"
                  (click)="redeemAll()">
                  Gesamtes Guthaben einlösen
                </button>
              }
            </p>
          }
        </div>

        <button hlmBtn size="lg" type="submit" class="w-full" [disabled]="!ready() || busy()">
          Weiter
        </button>
      </form>
    }
  </div>
</section>
